import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signNutritionalPrescriptionDocumentInput,
  useChSignChNutritionalCounsellingMutation as useChSignChNutritionalCounsellingMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignChNutritionalCounsellingMutation.graphql"

const mutation = graphql`
  mutation useChSignChNutritionalCounsellingMutation($input: Ch_signNutritionalPrescriptionDocumentInput!) {
    ch_signNutritionalPrescriptionDocument(input: $input) {
      ch_NutritionalPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chNutritionalCounsellingFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignChNutritionalCounsellingMutationType>, "variables"> & {
  id: Ch_signNutritionalPrescriptionDocumentInput["id"]
}

const useChSignChNutritionalCounsellingMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignChNutritionalCounsellingMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignChNutritionalCounsellingMutation }
